import { render } from "./DeveloperForm.vue?vue&type=template&id=47579046&scoped=true&ts=true"
import script from "./DeveloperForm.vue?vue&type=script&lang=ts"
export * from "./DeveloperForm.vue?vue&type=script&lang=ts"

import "./DeveloperForm.vue?vue&type=style&index=0&id=47579046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47579046"]])

export default __exports__